import React, { useState, useEffect } from 'react';

import { useWebSocket } from "contexts/WebSocketContext";
import { useAuth } from "contexts/AuthContext";
// import { useSystemPortalConfigStore } from 'zustandStore/slice/system'
import useZustandStore from "zustandStore"

import { v4 as uuidv4 } from "uuid";

import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress"

// ==============================|| AUTH GUARD ||============================== //

const CHECK_MOCKUP = process.env.REACT_APP_IS_MOCKUP;

// 這裡只處理 global fetch api 請勿添加其他類型的 API

export default function AuthGuard({ fetchSystemFlag, setFetchSystemFlag, children }) {
  const ws = useWebSocket();
  const { token } = useAuth();

  // 取得 Zustand 的狀態
  const loading = useZustandStore((state) => state.loading);
  const setPortalConfigLoading = useZustandStore((state) => state.setPortalConfigLoading);

  const setPortalConfig = useZustandStore((state) => state.setPortalConfig);

  const fetchSystemPortalConfig = useZustandStore((state) => state.fetchSystemPortalConfig);
  // 拿存在 Zustand 的狀態
  // const portalConfig = useZustandStore((state) => state.portalConfig);

  const [systemPortalConfigUuid, _setSystemPortalConfigUuid] = useState(uuidv4());

  useEffect(() => {
    if (fetchSystemFlag) {
      setPortalConfigLoading(true);
      // fetch 資料
      fetchSystemPortalConfig(ws, systemPortalConfigUuid, token)
    }
  }, [fetchSystemFlag])

  useEffect(() => {
    if (CHECK_MOCKUP === "true") {
      setPortalConfigLoading(false);
      setFetchSystemFlag(false);
      return;
    }
    if (!ws) return;

    const handleMessage = (system) => {
      // Ignore malformed WebSocket events and error responses (which have no result.data).
      if (typeof system?.data !== "string") return;

      let msg;
      try {
        msg = JSON.parse(system.data);
      } catch (error) {
        console.error("Failed to parse WebSocket message:", error);
        return;
      }

      if (msg.id !== systemPortalConfigUuid) return;

      if (msg.error || !msg.result?.data) {
        setPortalConfigLoading(false);
        setFetchSystemFlag(false);
        return;
      }

      // 存資料
      setPortalConfig(msg.result.data)
      setPortalConfigLoading(false);
      setFetchSystemFlag(false);
    };

    ws.addEventListener("message", handleMessage);

    return () => {
      ws.removeEventListener("message", handleMessage);
    };
  }, [ws]);

  return loading ? <Box
    sx={{
      display: "flex",
      flexDirection: "row",
      gap: 2,
      alignItems: "center",
      justifyContent: "center",
      width: "100%",
      height: "100vh"
    }}>
    <CircularProgress />
  </Box> : children;
}
